import React, { useContext, useEffect } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import useAuthService from '../../app/services/hooks/useAuthService';
import { ServiceResponse } from '../../app/services/shared/interfaces';

type Props = {
    children: React.ReactNode;
};

const PrivateMiddleware: React.FC<Props> = ({ children }) => {
    const { auth, updateAuth, logout, loading, logged } = useContext(AuthContext);
    const { validateTokenAuth } = useAuthService();

    useEffect(() => {
        if (logged != undefined) {
            validateTokenAuth({
                onSuccess: (response: ServiceResponse) => {
                    if (auth && updateAuth) {
                        updateAuth({
                            ...auth,
                            id: response.data.id,
                            firstName: response.data.first_name,
                            lastName: response.data.last_name,
                            email: response.data.email,
                            avatar: response.data.avatar,
                            roles: response.data.roles,
                            permissions: response.data.permissions,
                            hasAllPermissions: response.data.hasAllPermissions,
                            organization: response.data.organization ?? null,
                            branding: response.data.branding ?? null
                        });
                    }
                },
                onError: (response) => {
                    if (logout && response?.http_status === 401) {
                        logout();
                    }
                }
            });
        }
    }, [logged]);

    useEffect(() => {
        if (!loading && !auth && logout) logout();
    }, [auth, loading]);

    return !auth ? null : <>{children}</>;
};

export default PrivateMiddleware;
